import React, { useRef, useState } from 'react';
import { useVisibility } from '@wearejh/react-hooks/lib/useVisibility';

import { Wrapper } from '../Layout';
import { useYotpoWidget, YotpoWidgetProps } from '../Yotpo';

import classes from './ProductDetail.scss';

type ProductReviewsProps = Pick<YotpoWidgetProps, 'product' | 'price'>;

export const ProductReviews = React.memo(function ProductReviews(props: ProductReviewsProps) {
    const { ProductReviews } = useYotpoWidget();
    const ref = useRef<HTMLElement>(null);
    const [isReady, setReady] = useState(false);

    useVisibility(ref, setReady, options);

    return (
        <div ref={ref as any}>
            <Wrapper variant="page-inner" id="ProductReviews" className={classes.reviewsLoader}>
                {isReady && <ProductReviews {...props} />}
            </Wrapper>
        </div>
    );
});

const options: IntersectionObserverInit = {
    rootMargin: '75px',
};
